import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { dashboardApi } from "@/lib/dashboard";

export function JobsWidget() {
  const q = useQuery({
    queryKey: ["dashboard", "jobs"],
    queryFn: () => dashboardApi.jobs(),
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
  });

  return (
    <Card>
      <CardHeader><CardTitle>Jobs</CardTitle></CardHeader>
      <CardContent>
        {q.isLoading ? (
          <Skeleton className="h-9 w-28" />
        ) : q.isError || !q.data ? (
          <p className="text-sm text-muted-foreground">Couldn't load jobs.</p>
        ) : q.data.inProductionStage === 0 && q.data.awaitingArtwork === 0 && q.data.awaitingApproval === 0 ? (
          <p className="text-sm text-muted-foreground">No active jobs.</p>
        ) : (
          <Link to="/jobs" className="block hover:underline">
            <span className="text-3xl font-semibold">{q.data.inProductionStage}</span>{" "}
            <span className="text-sm text-muted-foreground">in production</span>
            <div className="text-sm text-muted-foreground mt-1">
              {q.data.awaitingArtwork} awaiting artwork · {q.data.awaitingApproval} awaiting approval
            </div>
          </Link>
        )}
      </CardContent>
    </Card>
  );
}
